import { TGraphicDesignLessonConfig } from '../../../models/courses/graphicDesign';
import { evaluate, TGDEvaluation, TGDAnswers } from '../core/engine';
import { deriveCritiqueConfig } from '../student/critique';
import { findRule } from './ruleTemplates';

export const checkSolution = (config: TGraphicDesignLessonConfig): TGDEvaluation | null => {
  const isRead = config.exerciseType === 'CHOOSE' ||
    (config.exerciseType === 'INTENT' && !!config.versions?.length);
  const isCritique = config.exerciseType === 'CRITIQUE';
  if (!isRead && !isCritique && !config.solution) return null;
  const answers: TGDAnswers = { firstTryWrong: false };
  if (isCritique) {
    answers.zones = Object.fromEntries((config.zones ?? []).map(zone => [zone.id, zone.correct]));
  }
  if (isRead) {
    answers.choiceId = findRule(config.rules, 'choiceEquals')?.params.choiceId;
    answers.reasonId = findRule(config.rules, 'reasonEquals')?.params.reasonId;
  }
  const initial = config.exerciseType === 'TRANSFORM' && config.initialState?.mode === 'inline'
    ? config.initialState.design : undefined;
  return evaluate(isCritique ? deriveCritiqueConfig(config) : config, {
    design: config.solution ?? config.versions?.[0]?.design ?? initial ??
      { background: config.background, components: [] },
    initial, answers, elapsedMs: 0, artboard: config.artboard, zones: config.zones,
  });
};
